import ApiService from "@/core/services/ApiService";

class SanctionService {

    public static save(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/sanctions/save', data)
    }

    public static update (id, data) {
        ApiService.setHeader()
        return ApiService.put(`api/sanctions/${id}/update`,data)
    }

    public static delete(id: string) {
        ApiService.setHeader()
        return ApiService.delete(`api/sanctions/${id}`, 'delete')
    }
}

export default SanctionService;